import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline'
import { uploadImage, buildCloudinaryFolder } from '../../../utils/cloudinary'

function GalleryForm({ items, onItemsChange, userId, vcardId }) {
  const [showForm, setShowForm] = useState(false)
  const [formData, setFormData] = useState({ title: '', imageUrl: '' })

  const handleUpload = async (e) => {
    const file = e.target.files[0]
    if (!file || !userId || !vcardId) {
      if (!userId || !vcardId) {
        alert('Error: No se puede subir la imagen. Falta información del usuario o Dkard.')
      }
      return
    }
    
    try {
      // Build folder path for Cloudinary
      const folder = buildCloudinaryFolder(userId, vcardId, 'gallery')
      
      // Upload to Cloudinary
      const { url } = await uploadImage(file, folder)
      
      // Update form with Cloudinary URL
      setFormData({ ...formData, imageUrl: url })
    } catch (error) {
      console.error('Error uploading image:', error)
      alert('Error al subir la imagen: ' + error.message)
    }
  }

  const addItem = () => {
    if (!formData.imageUrl) return
    const item = { id: Date.now().toString(), title: formData.title.trim(), imageUrl: formData.imageUrl }
    onItemsChange([...(items || []), item])
    reset()
  }

  const removeItem = (id) => {
    if (window.confirm('¿Eliminar esta imagen?')) {
      onItemsChange(items.filter(i => i.id !== id))
    }
  }

  const reset = () => {
    setFormData({ title: '', imageUrl: '' })
    setShowForm(false)
  }

  return (
    <div className="space-y-6">
      {items && items.length > 0 && (
        <div className="space-y-4">
          <h3 className="text-lg font-medium text-gray-900">Tu Galería ({items.length})</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((it) => (
              <div key={it.id} className="bg-white border rounded-lg p-3">
                <img src={it.imageUrl} alt={it.title || 'Imagen'} className="w-full h-32 object-cover rounded" onError={(e) => { e.currentTarget.src = 'https://via.placeholder.com/300x200/e2e8f0/64748b?text=Imagen' }} />
                {it.title && <p className="mt-2 text-sm text-gray-700 truncate">{it.title}</p>}
                <button onClick={() => removeItem(it.id)} className="mt-2 w-full text-sm text-red-600 hover:text-red-800 border border-red-200 rounded py-1">
                  <TrashIcon className="w-4 h-4 inline mr-1" /> Eliminar
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="border-t pt-6">
        {!showForm ? (
          <button onClick={() => setShowForm(true)} className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
            <PlusIcon className="w-4 h-4 mr-2" /> Agregar Imagen
          </button>
        ) : (
          <div className="bg-gray-50 rounded-lg p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Título</label>
                <input type="text" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" placeholder="Opcional" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Imagen *</label>
                <div className="space-y-2">
                  <input type="file" accept="image/*" onChange={handleUpload} className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
                  {formData.imageUrl && (
                    <img src={formData.imageUrl} alt="Preview" className="w-24 h-24 object-cover rounded" />
                  )}
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-3 mt-6">
              <button type="button" onClick={reset} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">Cancelar</button>
              <button type="button" onClick={addItem} disabled={!formData.imageUrl} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-300">Agregar Imagen</button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

GalleryForm.propTypes = {
  items: PropTypes.array.isRequired,
  onItemsChange: PropTypes.func.isRequired,
  userId: PropTypes.string,
  vcardId: PropTypes.string,
}

export default GalleryForm
